import { IonIcon } from '@ionic/react'
import { Box, Grid, Radio } from '@mui/material'
import { PriceDetails, ProductLabels } from '@vae/server/src/types/synerallApiTypes'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { calendarClear, logoEuro, pieChart } from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'

dayjs.extend(utc)
dayjs.extend(timezone)

interface Props {
	id: string
	price: PriceDetails
	texts: ProductLabels
	selected: boolean
	handleSelect: (id: string) => void
}

const LockInCard: React.FC<Props> = ({ id, price, selected, texts, handleSelect }) => {
	const { t } = useTranslation('modals_createContract', { keyPrefix: 'lockInDetailsStep' })

	return (
		<div className='lock-in-card-container'>
			<Grid item xs={12} sm={6} md={4} lg={4}>
				<Box
					className='lock-in-card dark:bg-[linear-gradient(75deg,_#3cb49f_0%,_#cae3cc_100%)] bg-[linear-gradient(75deg,_#d6e4ff_0%,_#c9f7d3_100%)]'
					onClick={() => {
						handleSelect(id)
					}}
				>
					<div className='content'>
						<Radio
							className='radio dark:[&_.MuiSvgIcon-root]:text-brand-primary-200-dark [&_.MuiSvgIcon-root]:text-brand-secondary-100-light [&_.MuiSvgIcon-root]:m-0'
							checked={selected}
						/>
						<div className='dates text-brand-secondary-100-light'>
							<div className='month'>{texts.title}</div>
							<div className='days'>{texts.subtitle}</div>
						</div>
						<div className='prices-container text-brand-secondary-100-light dark:text-brand-primary-200-dark'>
							<div className='price'>
								<span className='child title'>
									<IonIcon icon={logoEuro} /> {t('hourlyPrice')}
								</span>
								<span className='child'>
									{price.hourlyPrice.toFixed(2).replace('.', ',')} {price.hourlyPriceUnit}
								</span>
							</div>
							<div className='price'>
								<span className='child title'>
									<IonIcon icon={calendarClear} /> {t('monthlyPrice')}
								</span>
								<span className='child'>
									{price.monthlyPrice.toFixed(2).replace('.', ',')} {price.monthlyPriceUnit}
								</span>
							</div>
							<div className='price'>
								<span className='child title'>
									<IonIcon icon={pieChart} /> {t('fixedRatio')}
								</span>
								<span className='child'>
									{price.fixedRatio}
									{price.fixedRatioUnit}
								</span>
							</div>
						</div>
						<div className='disclaimer-container'>
							<div className='disclaimer'>{t('disclaimer')}</div>
						</div>
					</div>
				</Box>
			</Grid>
		</div>
	)
}

export default LockInCard
